import { getCurrentUser } from '@data/store/slices/currentUser/getters'
import { getExperimentTrackingSegments } from '@data/store/slices/unsyncedData/getters'
import { GACustomDimensions } from '@tracking/events'
import { isAdminUser, isAlbatross, isAmbassador, isConsul } from '@util/member'

const getGAPrimaryUserRole = (userRoles: TUserRole[]) =>
    isAdminUser(userRoles)
        ? 'admin'
        : isAmbassador(userRoles)
          ? 'ambassador'
          : isConsul(userRoles)
            ? 'consul'
            : isAlbatross(userRoles)
              ? 'albatross'
              : 'basic'

export const getGACustomDimensions = (): GACustomDimensions => {
    const currentUser = getCurrentUser()
    const experimentTrackingSegments = getExperimentTrackingSegments()

    return {
        experiment_runs: experimentTrackingSegments,
        login_state: currentUser?.id ? '1' : '0',
        lc_id: currentUser?.localcommunityId ? currentUser.localcommunityId.toString() : '',
        lc_segment: currentUser?.localcommunity.segment ?? '',
        user_role: currentUser?.roles ? getGAPrimaryUserRole(currentUser.roles) : '',
    }
}
